export default function () {
  return {
    contaCorrente: {
      data: [],
    },
  };
}
